<template>
  <div id="internship">
    <v-card class="white--text" color="black" elevation="0" flat style="border-radius:0px;">
      <v-container grid-list-xl>
        <v-layout align-center justify-center row wrap>
          <v-flex sm4 xs11>
            <v-img
              :aspect-ratio="16 / 9"
              :lazy-src="require('@/assets/school/logo_internship.png')"
              :src="require('@/assets/school/logo_internship.png')"
            ></v-img>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex sm6 text-xs-center xs12>
            <div class="spacing-2 headline font-weight-bold">{{ headerTitle }}</div>
            <div class="subheading font-weight-bold mt-2" style="color:#00FF00">
              {{ subHeaderText }}
            </div>
            <div class="spacing-2" style="font-size:8px;">{{ captionText }}</div>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row wrap>
          <v-flex pb-0 sm4 text-xs-center xs10>
            <div class="subheading font-weight-bold">{{ propertyTitlte }}</div>
            <div class="caption font-weight-bold mt-2">{{ propertyText }}</div>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row wrap>
          <v-flex py-0 sm4 xs7>
            <v-img
              :aspect-ratio="16 / 9"
              contain
              :lazy-src="require('@/assets/school/logo_internship_alumnus.png')"
              :src="require('@/assets/school/logo_internship_alumnus.png')"
            ></v-img>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex pt-0 px-0 sm4 xs12>
            <!-- Alumnus swiper -->
            <swiper :options="swiperOptionAlumnus">
              <swiper-slide :key="index" v-for="(techfarmAlumnu, index) in techfarmAlumnus.length">
                <v-card color="white" elevation="0" width="300">
                  <v-layout align-center row wrap>
                    <v-flex xs4>
                      <v-img
                        aspect-ratio="1"
                        class="grey lighten-2"
                        :lazy-src="require('@/assets/NoPicture.png')"
                        :src="
                          techfarmAlumnus[index].picture
                            ? techfarmAlumnus[index].picture
                            : require('@/assets/NoPicture.png')
                        "
                      >
                        <template v-slot:placeholder>
                          <v-layout align-center fill-height justify-center ma-0>
                            <v-progress-circular
                              color="grey lighten-5"
                              indeterminate
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex xs6>
                      <div class="caption font-weight-bold">
                        {{
                          `${techfarmAlumnus[index].firstname} (${techfarmAlumnus[index].nickname})`
                        }}
                      </div>
                      <div style="font-size:9px">{{ techfarmAlumnus[index].branch }}</div>
                      <div style="font-size:9px">{{ techfarmAlumnus[index].school }}</div>
                      <div style="font-size:9px">
                        {{
                          `นักศึกษาปี ${techfarmAlumnus[index].year}, ${
                            techfarmAlumnus[index].types
                          }`
                        }}
                      </div>
                    </v-flex>
                    <v-flex mb-4 mx-4 text-xs-center xs12>
                      <div class="caption font-weight-bold spacing-1">
                        {{ `"${techfarmAlumnus[index].recommend}"` }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </swiper-slide>
            </swiper>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex my-3 sm4 text-xs-center xs10>
            <div class="caption font-weight-bold">{{ jobDescTitle }}</div>
            <div class="caption font-weight-bold">{{ jobDescText }}</div>
          </v-flex>
        </v-layout>

        <v-layout align-center justify-center row wrap>
          <v-flex px-0 sm4 xs12>
            <!-- Intern swiper -->
            <swiper :options="swiperOptionIntern">
              <swiper-slide :key="n" v-for="n in 31">
                <v-img
                  :aspect-ratio="16 / 9"
                  class="grey lighten-2"
                  :lazy-src="require('@/assets/NoPicture.png')"
                  :src="require(`@/assets/school/slide/slide-${n}.jpg`)"
                >
                  <template v-slot:placeholder>
                    <v-layout align-center fill-height justify-center ma-0>
                      <v-progress-circular
                        color="grey lighten-5"
                        indeterminate
                      ></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>
              </swiper-slide>
            </swiper>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row wrap>
          <v-flex my-3 text-xs-center xs9>
            <span class="subheading font-weight-bold pr-2">{{ registerText }}</span>
            <a
              class="headline font-weight-bold"
              :href="registerLink"
              style="color:#76FF03"
              target="blank"
              >คลิกที่นี้</a
            >
          </v-flex>
          <v-flex text-xs-center xs10>
            <div class="subheading font-weight-bold">{{ contractText }}</div>
            <div class="headline font-weight-bold mt-2" @click="window.open('tel:0933171414')">
              {{ contractPhone }}
            </div>
          </v-flex>
          <v-flex xs12>
            <div style="height:80px"></div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'internship',
  data() {
    return {
      headerTitle: `รับนักศึกษาร่วม(ฝึก)งาน`,
      subHeaderText: `ทำงานจริง - ระดับสาขาใดก็ได้ - ไม่สนเกรด`,
      captionText: `** หากเป็นลูกหลานเกษตรกรจได้รับการพิจราณาเป็นกรณีพิเศษ **`,
      propertyTitlte: `คุณมีคุณสมบัติดังนี้หรือไม่ ?`,
      propertyText: `กำลังศึกษาในระดับมัธยมศึกษา, ประกาศนียบัตรวิชาชีพ, ประกาศนียบัตรวิชาชีพชั้นสูง หรือ ปริญญาตรี ที่มีความสนใจที่จะพัฒนาคุณภาพชีวิตเกษตรกรไทย โดยตนเองเป็นคนที่เปิดรับและไม่ปิดกั้นการเรียนรู้สิ่งใหม่ๆตลอดเวลา และมีความต้องการและอยากพัฒนาตนเองให้เก่งมากยิ่งขึ้น`,
      jobDescTitle: `** ลักษณะงานขึ้นอยู่กับความสนใจของนักศึกษาแต่ละคน **`,
      jobDescText: `จำนวนนักศึกษาฝึกงานที่รับจะผันแปรตามช่วงเดือนที่มาฝึกงาน**มีที่พักฟรี! สำหรับนักศึกษาต่างจังหวัดหรือคนที่เดินทางลำบาก**`,
      registerText: `สนใจสมัคร`,
      registerLink: `https://forms.gle/y6AEYepe7R1fK5Vb8`,
      contractText: `สอบถามข้อมูลเพิ่มเติมได้ที่`,
      contractPhone: `(+66) 0933171414`,
      swiperOptionAlumnus: {
        effect: 'coverflow',
        centeredSlides: true,
        grabCursor: false,
        initialSlide: Math.floor(Math.random() * 6),
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        }
      },
      swiperOptionIntern: {
        spaceBetween: 20,
        centeredSlides: true,
        slidesPerView: 'auto',
        initialSlide: Math.floor(Math.random() * 32),
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      techfarmAlumnus: []
    }
  },
  created() {
    this.fetchAlumnus()
  },
  methods: {
    async fetchAlumnus() {
      try {
        const response = await this.axios.get(`portal/intern`)
        if (response.data.length) {
          this.techfarmAlumnus = response.data
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.spacing-1 {
  letter-spacing: 1px !important;
}
.spacing-2 {
  letter-spacing: 2px !important;
}
.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 300px;
}
</style>
